//accordion start
const accordion = document.querySelectorAll(".accordion-btn");

accordion.forEach((accordionElem) => {
    accordionElem.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    //console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      //console.log(content.style.maxHeight);
    }
  };
});
//accordion end

//set active link-anchor start
const anchorLinks = document.querySelectorAll(".faq-page__heading-linl-list a");

anchorLinks.forEach((anchorLinksElem) => {
  anchorLinksElem.onclick = function (e) {      
    anchorLinks.forEach(function (link) {
        link.classList.remove("active");
    });  
    this.classList.add("active");
  };
});
//set active link-anchor end